import React from 'react';
import { FormGroup } from 'reactstrap';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    onFieldChange,
    toasty,
    FormCheckbox,
    Input,
} from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { handleFormSaveError } from '../common/forms/ValidationError';
import './ManageTenantTheme.scss';

class TenantViewModel {
    constructor() {
        this.defaultColor = '';
        this.PrimaryColor = '';
        this.SecondaryColor = '';
        this.WarningColor = '';
        this.DangerColor = '';
        this.InfoColor = '';
        this.DefaultHighlightColor = '';
        this.DefaultHighlightAccentColor = '';
        this.SuccessColor = '';
        this.ShowBrandLabel = '';
    }
}

const Colors = [
    { name: 'defaultColor', label: 'Default Color' },
    { name: 'primaryColor', label: 'Primary Color' },
    { name: 'secondaryColor', label: 'Secondary Color' },
    { name: 'warningColor', label: 'Warning Color' },
    { name: 'dangerColor', label: 'Danger Color' },
    { name: 'infoColor', label: 'Info Color' },
    { name: 'defaultHighlightColor', label: 'Default Hightlight Color' },
    { name: 'defaultHighlightAccentColor', label: 'Default Hightlight Accent Color' },
    { name: 'successColor', label: 'Success Color' },
];

export class ManageTenantTheme extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const initialTenant = this.props.theme ?? new TenantViewModel();

        this.state = {
            theme: initialTenant,
            ...new BaseFormViewModel(),
        };

        this.onChange = this.onChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleSaveError = this.handleSaveError.bind(this);
    }

    componentDidMount() {
        const { show } = this.props;
        if (show) {
            this.open();
        }
    }

    onChange = onFieldChange;

    onClose = () => {
        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    onSubmit = async () => {
        const { theme } = this.state;
        this.setState({ errors: {}, saving: true });

        const url = ApiRoutes.tenant.themeById(theme.tenantCompanyId);
        const method = httpClient.put;
        const response = await method(url, theme).catch(this.handleSaveError);

        if (response) {
            this.onClose();
            toasty.success('Theme Saved', 'Theme saved successfully.');
        }
    };

    handleSaveError = (err) => handleFormSaveError(this, err);

    open = async (companyId) => {
        this.setState({ loading: true });
        this.resetForm();

        let theme;
        if (companyId) {
            theme = await httpClient.js(ApiRoutes.tenant.getThemeById(companyId));
        } else {
            theme = new TenantViewModel();
        }

        this.setState({ theme }, () => {
            this.props.toggleShow(true);
            this.context.setFormOpened(true);
            this.setState({ loading: false });
        });
    };

    resetForm() {
        this.setState({
            formValidated: false,
        });
    }

    render() {
        const { formValidated, validationMessage, theme } = this.state;

        const formTitle =
            !!parseInt(theme.tenantCompanyId ?? 0) > 0
                ? 'Edit Company Theme'
                : 'Add Company Theme';

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.props.show}
                id="themeForm"
                formIcon={faBuilding}
                formTitle={formTitle}
                ref={this.formRef}
                setIsValidated={(value) => {
                    this.setState({ formValidated: value });
                }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                error={validationMessage}
            >
                {Colors.map((color) => (
                    <Input
                        key={color.name}
                        label={color.label}
                        name={`theme.${color.name}`}
                        id={color.name}
                        onChange={this.onChange}
                        value={theme[color.name] || ''}
                        error={`${color.label} is required`}
                        endAddon={(
                            <div
                                className="color-preview"
                                style={{
                                backgroundColor: theme[color.name] || '#ffffff',
                            }}
                            />
                        )}
                        required
                    />
                ))}

                <FormGroup>
                    <FormCheckbox
                        id="showBrandLabel"
                        name="theme.showBrandLabel"
                        type="checkbox"
                        checked={theme.showBrandLabel}
                        onChange={this.onChange}
                        labelText="Show Brand Label"
                    />
                </FormGroup>
            </SlideForm>
        );
    }
}
